module.exports = __webpack_public_path__ + "f91fbb6457bdb37516af5cefefe2fdc7.fbx";